// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".auto-resize-textarea{overflow:hidden;resize:none;width:100%;background-color:rgba(0,0,0,0);padding:8px;font-size:14px;border:none}", ""]);
// Exports
module.exports = exports;
